import styled from 'styled-components';
import { Button } from '@lendi-ui/button';
import getColour from '@lendi-ui/commons/colours';
import { mb, pb } from '@lendi-ui/spacing';
import { select } from '@lendi-ui/theme';

export const Container = styled(Button)`
  border-radius: ${select('borderRadius')};
  height: auto;
  min-height: 120px;
  width: 100%;
  background-color: ${() => getColour('background', 'container')};
  ${mb('sm')}

  strong {
    display: block;
    font-size: 28px;
    line-height: 1;
    ${pb('xs')}
  }
`;
